import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';

export function MainLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <TopBar />

      <main className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex-1 w-full">
        <Outlet />
      </main>

      <footer className="bg-white border-t border-gray-200">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-sm text-gray-500">
            © {new Date().getFullYear()} SmartField. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
